<template>
  <div class="commitment-config" v-if="commitmentForm" v-resize="onResize">
    <el-card v-if="own_commitment">
      <div v-if="isNewCommitment">
        <h4 style="text-align: center" >This commitment will be created in "{{goal_name}}"</h4>
      </div>

      <el-form label-width="200px" :label-position="documentWidth > 1300 ? 'left' : 'top'" @submit.native.prevent>
        <el-form-item label="Short description or name">
          <el-input v-model="commitmentForm.meta.name" placeholder="Commitment name" autofocus></el-input>
        </el-form-item>

        <!-- <pre class="mini-pre">{{commitmentForm.user}}</pre> -->
        <!-- TODO: timeslotCollectionId is updated but not displayed! -->

        <el-form-item label="Picture">
          <div style="display: flex; flex-direction: column">
            <div
              class="commitment-picture"
              :style="{
                'background-image': 'url(' + commitmentForm.picture + ')'
              }">
            </div>
            <div>
              <ImageUpload v-model="commitmentForm.picture" :searchText="commitmentForm.meta.name" bucket="commitment_pics" />
            </div>
          </div>
        </el-form-item>
        <template v-if="commitmentForm.type === 'SEQUENCE'">
          <!-- <pre class="mini-pre">{{sequenceSelectOptions}}</pre> -->
          <el-form-item label="Which Routine?">
            <el-select v-model="commitmentForm.sequenceId" placeholder="Select a routine..." class="w-100">
              <el-option
                v-for="item in sequenceSelectOptions"
                :key="item.value"
                :value="item.value"
                :label="item.label"
                style="height: 50px; border-bottom: 1px solid rgb(232, 232, 232); margin: 0">
                <!-- todo: picture ? -->
                <strong style="line-height: 20px; margin: 0; padding-top: 2px; display: block;">{{item.label}}</strong>
                <p class="p-0 m-0" style="line-height: 15px">{{item.description}} <span v-if="item.length">({{item.length}} items)</span></p>
              </el-option>
            </el-select>
          </el-form-item>

          <!-- lastCompletedSeqItemId -->
          <!-- completedSequences -->
        </template>

        <template v-if="commitmentForm.type !== 'BACKLOG'">
          <el-form-item
            label="Schedule when?">
            <el-select v-model="commitmentForm.user.timeslotCollectionId" placeholder="Select schedule">
              <el-option
                v-for="item in timeslotCollectionsSelectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :style="{ width: '100%', color: item.color }">
              </el-option>
            </el-select>
          </el-form-item>

          <template v-if="commitmentForm.type === 'SEQUENCE'">
            <el-form-item label="Repeat how often?">
              <el-input-number v-model="commitmentForm.templateRepeat" :step="1" size="small" />
              <!-- <el-checkbox v-model="infinitRepeat" class="ml-4" size="small">Repeat infinitely</el-checkbox> -->
            </el-form-item>
            <el-form-item label="Planning mode">
              <!--<el-switch
                size="small"
                v-model="commitmentForm.allowSessionToBeSkipped"
                active-text="Skip sessions when necessary"
                inactive-text="Try to plan missed sessions as soon as possible"
                :active-value="true"
                :inactive-value="false">
              </el-switch>-->
              <el-radio-group v-model="commitmentForm.allowSessionToBeSkipped" >
                <el-radio :label="false" border>Finish all items in routine in planned order (default)</el-radio>
                <el-radio :label="true" border>Skip items if necessary (fixed duration of routine)</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>

          <template v-if="commitmentForm.type === 'TASKLIST'">
            <el-form-item label="Committed Time Total">
              <!-- TODO: Allow more precise control / Create "DurationPicker.vue"-->
              <!--<el-input type="number" v-if="show_manual_input_comitted_hours" v-model.number="commitmentForm.committedTimeDaily" />
              <el-slider v-else v-model="commitmentForm.committedTimeDaily" :max="1000" show-input />
              <el-button type="text" @click="show_manual_input_comitted_hours = !show_manual_input_comitted_hours" class="p-0">
                {{show_manual_input_comitted_hours ? 'Show slider' : 'Show manual input'}}
              </el-button>-->
              <duration-quick-settings
                v-model="commitmentForm.committedTime"
                :quickDurationSettings="{
                  '0 h': 0 * 60,
                  '1 h': 60 * 60,
                  '2 h': 120 * 60,
                  '3 h': 180 * 60,
                  '4 h': 240 * 60,
                  '5 h': 300 * 60,
                  '10 h': 600 * 60,
                  '15 h': 900 * 60,
                  '20 h': 1200 * 60,
                  '30 h': 1800 * 60,
                  '40 h': 2400 * 60,
                  '50 h': 3000 * 60,
                  '75 h': 4500 * 60,
                  '100 h': 6000 * 60,
                  '500 h': 30000 * 60,
                  '1.000 h': 60000 * 60,
                  '5.000 h': 300000 * 60,
                  '10.000 h': 600000 * 60
                }">
              </duration-quick-settings>
            </el-form-item>
          </template>
        </template>

        <!--<el-form-item label="Commitment type">
          <el-tag>{{commitmentForm.type}}</el-tag>
        </el-form-item>-->

        <template v-if="commitmentForm.type === 'TASKLIST' || commitmentForm.type === 'TIME_BASED_TASKLIST'">
          <el-form-item label="Committed Time per Day">
            <!-- TODO: Allow more precise control / Create "DurationPicker.vue"-->
            <!-- <el-time-picker arrow-control v-model="commitmentForm.committedTimePerDay" :picker-options="{ selectableRange: '00:00:00 - 10:00:00' }" -->
            <!-- <el-input type="number" v-if="show_manual_input_hours_per_day" v-model.number="commitmentForm.committedTimePerDay" />
            <el-slider v-else v-model="commitmentForm.committedTimePerDay" :step="0.25" :max="24" show-input />
            <el-button type="text" @click="show_manual_input_hours_per_day = !show_manual_input_hours_per_day" class="p-0">
              {{show_manual_input_hours_per_day ? 'Show slider' : 'Show manual input'}}
            </el-button> -->
            <duration-quick-settings
              v-model="commitmentForm.committedTimePerDay"
              :quickDurationSettings="{
                '0 min': 0 * 60,
                '5 min': 5 * 60,
                '10 min': 10 * 60,
                '15 min': 15 * 60,
                '20 min': 20 * 60,
                '25 min': 25 * 60,
                '30 min': 30 * 60,
                '45 min': 45 * 60,
                '1 h': 1 * 60 * 60,
                '2 h': 2 * 60 * 60,
                '3 h': 3 * 60 * 60,
                '4 h': 4 * 60 * 60,
                '5 h': 5 * 60 * 60,
                '6 h': 6 * 60 * 60,
                '7 h': 7 * 60 * 60,
                '8 h': 8 * 60 * 60,
              }">
            </duration-quick-settings>
          </el-form-item>

          <!-- TODO: commitmentForm.schedulingSequence -->

          <!--<el-form-item label="Lane settings">
            <el-checkbox v-model="commitmentForm.user.showFinished" label="Show finished tasks?" border></el-checkbox>
          </el-form-item>-->

          <!--<el-form-item label="Session length">
            <duration-quick-settings
              v-model="commitmentForm.sessionLength"
              :quickDurationSettings="{
                '5 min': 5 * 60,
                '10 min': 10 * 60,
                '15 min': 15 * 60,
                '20 min': 20 * 60,
                '25 min': 25 * 60,
                '30 min': 30 * 60,
                '45 min': 45 * 60,
                '60 min': 60 * 60
              }">
            </duration-quick-settings>
          </el-form-item>-->

        </template>

        <template v-if="commitmentForm.type === 'BACKLOG'">
        </template>
        <template v-if="commitmentForm.type === 'MAGICLIST'">
          ...
        </template>
        <template v-if="commitmentForm.type === 'TRELLO'">
          ...
        </template>

        <template v-if="commitmentForm.type === 'TASKLIST' || commitmentForm.type === 'TIME_BASED_TASKLIST' || commitmentForm.type === 'SEQUENCE'">

          <el-form-item label="Start Date">
            <date-selector
              v-model="commitmentForm.startDate"
              type="date"
              placeholder="First Day">
            </date-selector>
          </el-form-item>

          <el-form-item label="End Date">
            <date-selector
              v-model="commitmentForm.endDate"
              type="date"
              placeholder="Last Day">
            </date-selector>
          </el-form-item>
          <el-form-item label="Assign to goal member">
            <!-- <pre> {{goal_members}} </pre> -->
            <el-select
              v-if="goal_members.$readySome"
              v-model="commitmentForm.meta.assignedUserId"
              placeholder="Schedule when?">
              <el-option
                v-for="member in goal_members.items"
                :key="member.$key"
                :label="member.cachedName"
                :value="member.$id">
                <img class="user-mini-image"
                  :src="member.cachedProfilePic|defaultUserPic"
                  width="16"
                  height="16"
                  :title="member.cachedName" />
                {{member.cachedName}}
                <!--
                <img class="user-mini-image"
                  :src="get_contact_by_id(userId).profilePic|defaultUserPic"
                  width="16" height="16" />
                -->
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Commitment status">
            <el-radio-group v-model="commitmentForm.meta.active" >
              <el-radio :label="true" border>Active (default)</el-radio>
              <el-radio :label="false" border>Inactive / Paused</el-radio>
            </el-radio-group>
          </el-form-item>

        </template>

        <!--
        <el-row>
          <el-col :span="10">
            <div class="sub-title">Time commitment per day (hours):</div>
            <el-slider v-model="commitmentForm.commitmentTime" :step="0.5" :max="12"></el-slider>
          </el-col>
          <el-col :span="4">
            &nbsp;
          </el-col>
          <el-col :span="10">
            <div class="sub-title">Relative importance (for sunburst):</div>
            <el-slider v-model="commitmentForm.size"></el-slider>
          </el-col>
        </el-row>
        -->
      </el-form>

      <!-- <pre class="mini-pre">{{commitmentForm}}</pre>
      <pre v-if="SHOW_DEBUG">
commitmentForm.startDate {{ commitmentForm.startDate }}
commitmentForm.endDate   {{ commitmentForm.endDate }}
      </pre> -->

      <span class="dialog-footer clearfix">
        <!--<div style="float:left">
          <el-button size="" v-if="!isNewCommitment" type="danger" @click="deleteCommitment" class="float-left">Delete Commitment</el-button>
          <el-button size="" @click="onAdminConvertIntoChallenge" type="danger" plain>Admin: Convert into Challenge</el-button>
        </div>-->
        <div style="float: right">
          <el-button size="" type="primary" @click="onSaveOrCreate">{{ isNewCommitment ? 'Create' : 'Update'}}</el-button>
          <el-button size="" @click="onDone">Cancel</el-button>
        </div>
      </span>

    </el-card>
    <el-card v-else>
      This commitment belongs to another user.
    </el-card>

  </div>
</template>

<script>
//import DateSelector from '@/components/Elements/DateSelector'
import Vue from 'vue'
import moment from '@/moment-gp'
import ImageUpload from '@/components/Elements/ImageUpload'
import { MAGIC_UID_TEAM } from '@/api/task'
import resize from 'vue-resize-directive'

// TODO: Use responsive comonent
// TODO: Allow to assign to user !!!

// TODO: Move to prompt-folder
Vue.component('AdminAdditionalDataForChallenge', {
  template: `
  <div>
    <el-checkbox disabled v-model="createGoalOnInstatiation">createGoalOnInstatiation</el-checkbox><br />
    <el-checkbox disabled v-model="joinGoalOnInstatiation">joinGoalOnInstatiation</el-checkbox><br />
    picture: <el-input v-model="picture"></el-input><br />
    <el-checkbox v-model="allowToEdit">allowToEdit</el-checkbox><br />
  </div>
  `,
  data: () => ({
    createGoalOnInstatiation: false,
    joinGoalOnInstatiation: false,
    picture: '',
    allowToEdit: false
  }),
})

export default {
  props: {
    isNewCommitment: {
      required: true
    },
    goalId: {
      required: true
    },
    commitmentId: {
      required: true
    },
    memberId: {
      required: true
    },
    tscId: {
      default: null
    },
    newType: {}
  },
  directives: {
    resize
  },
  data: () => ({
    show_manual_input_comitted_hours: false,
    show_manual_input_hours_per_day: false,
    commitmentForm: null,
    documentWidth: document.documentElement.clientWidth
  }),
  watch: {
    commitmentId: {
      handler(commitmentId) {
        console.log("WATCHER commitmentId", commitmentId);
        if ( commitmentId && commitmentId !== 'PLACEHOLDER' ) {
          this.initConfigExistingCommitment()
        } else {
          this.initConfigNewCommitment()
        }
      },
      immediate: true
    }
  },
  computed: {
    timeslot_collection_list() {
      return this.$models.timeslotCollection.getList().itemsAsArray();
    },

    sessionLengthSelectOptions() {
      return ([
        { value: 5,   label: '5 min',  disabled: true },
        { value: 10,  label: '10 min', disabled: true },
        { value: 15,  label: '15 min', disabled: false },
        { value: 20,  label: '20 min', disabled: true },
        { value: 25,  label: '25 min', disabled: true },
        { value: 30,  label: '30 min', disabled: false },
        { value: 60,  label: '1 h',    disabled: false },
        { value: 90,  label: '1 h 30 min',    disabled: false },
        { value: 120, label: '2 h',    disabled: false },
        { value: 180, label: '3 h',    disabled: false },
        { value: 240, label: '4 h',    disabled: false },
        { value: 300, label: '5 h',    disabled: false },
        { value: 360, label: '6 h',    disabled: false },
        { value: 'custom', label: 'custom', disabled: true }
      ]);
    },

    own_commitment() {
      return ( this.commitmentForm.meta.assignedUserId === this.$models.user.defaultUserId
            || this.commitmentForm.meta.assignedUserId === MAGIC_UID_TEAM )
    },

    /*start_date: {
      get() {
        return this.commitmentForm.startDate
      },
      set(value) {
        console.log('new start_date:', value)
        this.commitmentForm.startDate = value
      }
    },

    end_date: {
      get() {
        return this.commitmentForm.endDate || moment()
      },
      set(value) {
        console.log('new end_date:', value)
        this.commitmentForm.endDate = value
      }
    },*/

    /* commitment() {
      let goalId = this.goalId === 'PLACEHOLDER' ? null : this.goalId;
      let commitmentId = this.commitmentId === 'PLACEHOLDER' ? null : this.commitmentId;

      if ( goalId && commitmentId ) {
        let commitment = this.$models.commitment.with({ goalId: goalId }).getNode( commitmentId );
        return commitment;
      } else {
        return null;
      }
    }, */

    // commitment_meta() {
    //   return this.$models.commitmentMeta.with({ goalId: this.goalId }).getNode( this.commitmentId );
    // },

    goal_name() {
      return this.$models.goalMeta.getNode( this.goalId ).name
    },

    goal_members() {
      return this.$models.goalMember.with({ goalId: this.goalId }).getList();
    },

    timeslotCollectionsSelectOptions() {
      let timeslotCollectionList = this.timeslot_collection_list.map(item => {
        return { value: item.$id, label: item.name, color: item.color }
      });
      let neverEntry = { value: null, label: '<Do not schedule>', color: '#888888' };
      let newEntry = { value: '<new>', label: '<New schedule>', color: '#000000' };
      return { ...timeslotCollectionList, neverEntry, newEntry };
    },

    sequenceSelectOptions() {

      let userId = this.$models.user.defaultUserId;
      let sequenceList = this.$models.sequence.subscribeQuery({ key: 'owner', value: userId }).asArraySorted();
      // let sequenceList = this.$models.sequence.subscribeList().asArraySorted();

      let sequenceListOptions = sequenceList.items.map( sequence => {
        return {
          value: sequence.$id,
          label: sequence.name,
          description: sequence.description,
          length: ( sequence.sequenceItemList || []).length,
        }
      })
      sequenceListOptions.push({
        value: 'NEW',
        label: '<create new>',
        description: 'Create a new sequence after saving.',
        length: null
      })
      return sequenceListOptions;
    }
  },
  methods: {
    onResize() {
      // TODO: move to effort modal!
      this.documentWidth = document.documentElement.clientWidth
    },

    initConfigNewCommitment() {
      console.log("showNewCommitmentForm");
      // TODO: Does not support other users!
      this.commitmentForm = this.$api.commitment_model_new({
        type: this.newType,
        goal_id: this.goalId
      })
      this.commitmentForm.startDate = moment.currentDate();
      this.commitmentForm.user.timeslotCollectionId = this.tscId;
      console.log("commitment_model_new: Created model", this.commitmentForm);
      // convert to moment?
    },

    initConfigExistingCommitment() {
      // TODO: Does not support other users!
      console.log("initConfig", this.goalId, this.commitmentId, this.memberId);
      // this.$models.commitment.with({ goalId: this.goalId }).subscribeNode( this.commitmentId )
      this.commitmentForm = this.$api.commitment_model_existing({
        member_id: this.memberId,
        commitment_id: this.commitmentId,
        goal_id: this.goalId
      })
      console.log("commitment_model_existing: Created model", this.commitmentForm);
    },

    resetConfig() {
      this.commitmentForm = null;
    },

    validatedStartAndEndDate() {

      // TODO: move validation to actions.js?
      console.log('validate', this.commitmentForm.startDate, this.commitmentForm.endDate)

      let startDateIsValid = this.commitmentForm.startDate && this.commitmentForm.startDate.isValid();
      let endDateIsValid = this.commitmentForm.endDate && this.commitmentForm.endDate.isValid();

      /* Check if startDate or endDate is null */
      if ( !startDateIsValid && !endDateIsValid ) {
        if (!confirm('Are you sure you want to save this commitment without a start date and without a deadline?')) {
          return
        }
      }

      /* <date-selector> always returns a moment object */
      let currentDate = moment.currentDate();
      let startDate = startDateIsValid
                    ? this.commitmentForm.startDate
                    : null;

      let endDate = endDateIsValid
                    ? this.commitmentForm.endDate
                    : null;

      if ( endDate &&
           startDate &&
           startDate > endDate ) {
        alert('Deadline has to be after start date.')
        throw new Error('Invalid dates');
      }
      if ( endDate && currentDate > endDate ) {
        alert('Warning: Deadline lies in the past') // TODO: this.$messageBox
      }

      if ( this.commitmentForm.user.timeslotCollectionId === '<new>' ) {
        alert("<new> not implemented");
        throw new Error('NOT_IMPLEMENTED')
      }

      this.commitmentForm.startDate = startDate;
      this.commitmentForm.endDate = endDate;
    },

    onDone() {
      this.$emit('done')
      this.resetConfig();
      // TODO: Delete TSC if commitment was not created
    },

    onSaveOrCreate() {
      if ( this.commitmentForm.type === 'BACKLOG' ) {
        this.onSaveOrCreateBacklog();
        return
      }

      try {
        this.validatedStartAndEndDate()
      } catch (e) {
        console.warn("Getting commitment data failed", e);
        return
      }

      console.log("*** Saving commitment with data", this.commitmentForm);

      let create_sequence_after_save = false;
      if ( this.commitmentForm.sequenceId === 'NEW' ) {
        this.commitmentForm.sequenceId = this.$models.sequence._get_uid();
        create_sequence_after_save = true;
      }

      this.commitmentForm.write_with_meta().then(commitment_id => {
        this.$emit('saved', this.commitmentForm);

        if ( create_sequence_after_save ) {
          this.onCreateNewSequenceFromExistingId( this.commitmentForm.sequenceId )
        }
      });

      this.onDone();
    },

    onSaveOrCreateBacklog() {
      console.log("onSaveOrCreateBacklog")

      // We don't have to create user settings
      this.commitmentForm.meta.assignedUserId = MAGIC_UID_TEAM;
      this.commitmentForm.startDate = null;
      this.commitmentForm.endDate = null;

      this.commitmentForm.write_with_meta().then(commitment_id => {
        this.$emit('saved', this.commitmentForm);
      });

      this.onDone();
    },

    /*deleteCommitment() {
      this.$confirm_delete_prompt('commitment').then(({ notify }) => {
        this.$api.commitment_delete({
          commitment_id: this.commitmentId,
          goal_id: this.goalId,
          is_backlog: this.commitmentForm.type === 'BACKLOG'
        }).then(() => {
          console.log('Commitment deleted');
          this.onDone();
          this.$emit('deleted');
        });
      })
    },*/

    onCreateNewSequenceFromExistingId( sequence_id ) {
      // TODO: Move to mixin / actions
      let sortidx = 100; // TODO
      let user_id = this.$models.user.defaultUserId;

      this.$prompt('Please enter sequence name', 'New Sequence', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        closeOnClickModal: false,
      }).then(({ value }) => {
        let form = this.$models.sequence.new_from_template({ name: value, user_id })
        form.sortidx = sortidx;
        form.write().then(id => {
          this.$router.push( '/sequence/' + id + '/editor' );
        })
      }).catch();
    },

    onAdminConvertIntoChallenge() {
      /* todo: move */
      let data = this.getCommitmentWithFormData();

      this.$msgbox({
        title: 'Additional challenge settings',
        message: this.$createElement(Vue.component('AdminAdditionalDataForChallenge'), {}),
        showCancelButton: true,
        beforeClose: (action, instance, done) => {
          if (action !== 'confirm') {
            done();
            return
          }

          let dataContainer = instance.$children.find( child => 'createGoalOnInstatiation' in child )
          console.log("dataContainer", dataContainer);

          let additional_challenge_data = dataContainer ? {
            createGoalOnInstatiation: dataContainer.createGoalOnInstatiation,
            joinGoalOnInstatiation:   dataContainer.joinGoalOnInstatiation,
            picture:                  dataContainer.picture,
            allowToEdit:              dataContainer.allowToEdit
          } : {};

          this.$api.challenge_create({
            type: this.commitment.type,
            data: {
              name: this.commitmentForm.name,
              ...additional_challenge_data,
              ...data
              /*
              name - ok
              startDate - ok
              endDate - ok
              timeslotCollectionId - ignored
              <empty_commitment_additional_type_specific_fields> - ok
              */
            }
          }).then(() => {
            done();
            this.onDone();
          })
        }
      });
    },
  },
  components: {
    //DateSelector,
    ImageUpload
  }
}
</script>

<style>
.commitment-config .el-form-item {
  margin-bottom: 10px;
}
.commitment-config .commitment-picture {
  display: block;
  background: #9a9a9a;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: calc(116px * 1.5);
  width: calc(170px * 1.5);
  float: right;
  color: white;
  margin-bottom: 1em;
  border-radius: 5px;
}
</style>
